// File: frontend/src/utils/SpinnerLoading.tsx

import "./SpinnerLoading.css";
import { useTranslation } from "react-i18next";

export const SpinnerLoading = () => {
  const { t } = useTranslation();
  return (
    <div className="spinner-container">
      <div className="spinner" />
      <span>{t("loading_label", "Yükleniyor...")}</span>
    </div>
  );
};